import { useState } from 'react';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/EmailOutlined';
import TelegramIcon from '@mui/icons-material/Telegram';
import LocalCafeIcon from '@mui/icons-material/LocalCafeOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopyRounded';
import CheckIcon from '@mui/icons-material/CheckRounded';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutwardRounded';
import LocationOnIcon from '@mui/icons-material/LocationOnOutlined';
import { useMagnetic, useTilt } from '../utility/motion';

const EMAIL = 'flavio.cecca00@gmail.com';

function SocialCard({social, index}) {
    const ref = useTilt(8);
    const SocialIcon = social.icon;
    return (
        <a
            ref={ref}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className="social card tilt"
            data-reveal
            style={{ '--d': `${index * 80}ms`, '--c': social.color }}
        >
            <span className="card__spotlight" aria-hidden="true" />
            <span className="social__icon"><SocialIcon /></span>
            <span className="social__text">
                <span className="social__name">{social.name}</span>
                <span className="social__desc">{social.description}</span>
            </span>
            <ArrowOutwardIcon className="social__arrow" />
        </a>
    );
}

function Contacts({checked}) {
    const [copied, setCopied] = useState(false);
    const mailRef = useMagnetic(0.15);

    const socials = [
        { name: 'LinkedIn', url: 'https://it.linkedin.com/in/flavio-ceccarelli-38473a1b9', icon: LinkedInIcon, color: '#0a8fd8', description: checked ? 'Connettiti professionalmente' : 'Connect professionally' },
        { name: 'GitHub', url: 'https://github.com/carellice', icon: GitHubIcon, color: '#a1a1aa', description: checked ? 'Esplora il mio codice' : 'Explore my code' },
        { name: 'Telegram', url: 'https://t.me/flacec', icon: TelegramIcon, color: '#229ed9', description: checked ? 'Messaggio veloce' : 'Quick message' },
        { name: checked ? 'Offrimi un caffè' : 'Buy me a coffee', url: 'https://www.paypal.com/paypalme/flaviocecca', icon: LocalCafeIcon, color: '#f5b400', description: checked ? 'Supporta il mio lavoro' : 'Support my work' },
    ];

    const copyEmail = async () => {
        try {
            await navigator.clipboard.writeText(EMAIL);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            window.location.href = `mailto:${EMAIL}`;
        }
    };

    return (
        <section className="section contacts" id="contacts" aria-labelledby="contacts-title">
            <div className="section__head" data-reveal>
                <span className="eyebrow">{checked ? 'Contatti' : 'Contacts'}</span>
            </div>

            <div className="contacts__hero" data-reveal>
                <h2 className="contacts__title" id="contacts-title">
                    {checked ? 'Hai un’idea?' : 'Got an idea?'}
                    <br />
                    <span className="contacts__title-accent">{checked ? 'Parliamone.' : 'Let’s talk.'}</span>
                </h2>

                <div className="mail-pill">
                    <a ref={mailRef} href={`mailto:${EMAIL}`} className="mail-pill__link magnetic">
                        <EmailIcon className="mail-pill__icon" />
                        <span>{EMAIL}</span>
                    </a>
                    <button
                        type="button"
                        className={`mail-pill__copy ${copied ? 'is-copied' : ''}`}
                        onClick={copyEmail}
                        aria-label={checked ? 'Copia indirizzo email' : 'Copy email address'}
                    >
                        {copied ? <CheckIcon /> : <ContentCopyIcon />}
                        <span className="mail-pill__copy-label" aria-live="polite">
                            {copied ? (checked ? 'Copiata!' : 'Copied!') : (checked ? 'Copia' : 'Copy')}
                        </span>
                    </button>
                </div>
            </div>

            <div className="contacts__grid">
                {socials.map((social, index) => (
                    <SocialCard key={social.url} social={social} index={index} />
                ))}
            </div>

            <p className="contacts__location mono" data-reveal>
                <LocationOnIcon className="contacts__location-icon" />
                {checked ? 'Roma — Disponibile per nuove opportunità' : 'Rome — Available for new opportunities'}
            </p>
        </section>
    );
}

export default Contacts;
